/* unplugin-vue-components disabled */import script from "./RoleDataCollapse.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleDataCollapse.vue?vue&type=script&setup=true&lang=js"

import "./RoleDataCollapse.vue?vue&type=style&index=0&id=5b5d0b26&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b5d0b26"]])

export default __exports__